import { render, staticRenderFns } from "./ContextMenuMobile.vue?vue&type=template&id=f8ed2dc4&"
import script from "./ContextMenuMobile.vue?vue&type=script&lang=js&"
export * from "./ContextMenuMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports